import { UserAvatar } from '@/components/shared/UserAvatar';
import { Box } from '@mui/material';

type Props = { name?: string | null; picture?: string | null };

export const UserAvatarCell = ({ name, picture }: Props) => {
  return (
    <Box
      sx={{
        width: '300px',
        display: 'flex',
        alignItems: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        overflow: 'hidden',
        whiteSpace: 'normal',
        fontWeight: 600,
      }}
    >
      <UserAvatar
        name={name}
        picture={picture}
        sx={{ width: '24px', height: '24px', mr: 0.8, fontSize: '1.4rem' }}
      />
      {name}
    </Box>
  );
};
